module.exports = __webpack_public_path__ + "img/moon.c65bdf15.svg";